<template>
  <bpb-form
    slot="content"
    v-model="fields"
    :before-submit-hook="beforeSubmitHook"
  >
    <slot />
  </bpb-form>
</template>

<script>
export default {
  inject: {
    setParam: {
      default() {
        return () => {};
      },
    },
  },
  data() {
    return {
      fields: {},
    };
  },
  watch: {
    fields: {
      deep: true,
      handler(fields) {
        // refresh whole object instead of using "reference"
        this.setParam('page', 0);
        this.setParam('query', JSON.parse(JSON.stringify(fields)));
      },
    },
  },
  methods: {
    beforeSubmitHook(fields) {
      return false;
    },
  },
};
</script>
